import moment from "moment";
import { isDate } from "../utility";

const colors = {
  success: "#1677ff",
  error: "#ff4d4f",
};

const getColor = (errMessage, type) => {
  console.log('errMessage, type', {errMessage, type});
  if (type) {
    if (errMessage && errMessage.type === type) {
      return colors.error;
    }
    return colors.success;
  }
  return errMessage ? colors.error : colors.success;
};


const formatCellData = (data) => {
  // Data type is datetime
  if (isDate(data)) {
    return moment(data).format("DD/MM/YYYY HH:mm");
  }

  // Data type is Boolean
  if (typeof data === "boolean") {
    return data ? "❌" : "";
  }

  return data;
};

const CHECKBOX = "checkbox";
const INPUT = "input";
const NODATA = "no data to export";

export { getColor, formatCellData, CHECKBOX, INPUT, NODATA, colors };
